import React, { ReactNode } from "react";
import "./MessageContainer.css";

import SvgWarning from "../../../Icons/NotificationMessage/Warning";
import SvgSuccess from "../../../Icons/NotificationMessage/Success";
import SvgError from "../../../Icons/NotificationMessage/Error";

interface MessageContainer {
  icon?: ReactNode;
  message: ReactNode;
  variant: "success" | "warning" | "error";
}

const iconMap = {
  success: <SvgSuccess />,
  warning: <SvgWarning />,
  error: <SvgError />,
};

const MessageContainer = (props: MessageContainer) => {
  const { icon = iconMap[props.variant], variant, message } = props;
  return (
    <div className={`messageContainer ${variant}-bg`}>
      {icon}
      <p className="message">{message}</p>
    </div>
  );
};

export default MessageContainer;
